import { useContext, useMemo } from 'react'
import { FeatureFlagContext } from '@app/components/common/FeatureFlagProvider'
import { FeatureFlagName } from '@app/services/featureFlags/types'

export const useFeatureFlag = (flagName: FeatureFlagName): boolean => {
  const { featureFlags } = useContext(FeatureFlagContext)

  const featureFlagState = useMemo(() => {
    return !!featureFlags?.[flagName]
  }, [featureFlags, flagName])

  return featureFlagState
}

export const useFeatureFlags = (
  flagNames: FeatureFlagName[]
): Partial<Record<FeatureFlagName, boolean>> => {
  const { featureFlags } = useContext(FeatureFlagContext)

  const featureFlagStates = useMemo(() => {
    return flagNames.reduce(
      (acc, flagName) => {
        acc[flagName] = !!featureFlags?.[flagName]
        return acc
      },
      {} as Partial<Record<FeatureFlagName, boolean>>
    )
  }, [featureFlags, flagNames])

  return featureFlagStates
}

export const useFeatureFlagContext = () => {
  return useContext(FeatureFlagContext)
}

